import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedDate } from 'react-intl';

import { Card, CardHeader, CardText } from 'material-ui/Card';
import { browserHistory } from 'react-router';
import UserSkillInformationSegment from './UserSkillInformationSegment';

import DetailView from '../Common/DetailView';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import SkillIcon from 'material-ui/svg-icons/social/public';

import CourseActions from '../../actions/CourseActionCreator';
import CourseStore from '../../stores/CourseStore';
import ModuleActions from '../../actions/ModuleActionCreator';
import ModuleStore from '../../stores/ModuleStore';
import SkillActions from '../../actions/SkillActionCreator';
import SkillStore from '../../stores/SkillStore';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';
import { DateStyles } from '../../constants/CentricConstants';
import { statusColours } from '../../constants/ColourConstants';
import { withId, withMyUserId } from '../Common/Decorators';
import CourseCard from '../Course/CourseCard';
import Error404 from '../Pages/Error404';

import ModuleListItem from '../Module/ModuleListItem.react';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';

const style = {
    icon: {
        height: '32px',
        width: '32px',
    },
    expired: {
        color : statusColours.error,
    }
};

const getMenuItems = ({id}, onDelete) => [
    {
        link: `/dashboard/skill/${id}/edit`,
        icon: <EditIcon />,
        label: 'Edit',
        condition: {
            roles: [ROLES.ADMIN]
        }
    },
    { type:'divider' },
    {
        link: '/logout',
        icon: <CancelIcon />,
        label: 'Sign out',
    }
];

class Skill extends Component {

    constructor (props) {
        super(props);
        this.state = {
            details: {
                id: '',
                name: '',
                description: '',
                criteria: '',
                validFrom: '',
                validTo: '',
                lifetime: '',
                listOrder: '',
                status: '',
                type: '',
                level: '',
                group: '',
                trainer: '',
                code: '',
                certificate: '',
                sysStatus: '',
            },
            error: false,

            courses: [],
            modules: [],

            actions: [],

            links: {
                back: '/dashboard/skills',
                edit: '',
            }
        };
        this.onChange = this.onChange.bind(this);
        this.onCourseChange = this.onCourseChange.bind(this);
        this.onModuleChange = this.onModuleChange.bind(this);
        this.onDelete = this.onDelete.bind(this);
    }

    componentWillMount() {
        this.setState({actions: buildContextMenu(getMenuItems(this.props, this.onDelete), this.context.auth)});
    }

    componentDidMount() {
        this.listeners = [
            SkillStore.addListener(this.onChange),
            CourseStore.addListener(this.onCourseChange),
            ModuleStore.addListener(this.onModuleChange),
        ];

        SkillActions.getById(this.props.id);
        CourseActions.getBySkill(this.props.id);
        ModuleActions.getAll({skillId: this.props.id});

        // load already cached values;
        this.onCourseChange();
        this.onModuleChange();
    }

    componentWillUnmount() {
        this.listeners.forEach(listener => listener.remove());
    }

    render () {
        if (this.state.error) { return <Error404/>; } //guard

        const today = new Date();
        const validFrom = new Date(this.state.details.validFrom);

        let isActive =  (today >= validFrom);

        let skillValidFrom = '';
        if (this.state.details.validFrom) {
            skillValidFrom = <FormattedDate value={this.state.details.validFrom} {...DateStyles.long} />;
        }

        let validTo = '';

        if (!!this.state.details.validTo) {

            if (today > new Date(this.state.details.validTo)) {
                isActive = false;
            }

            validTo = (
                <span style={!isActive ? style.expired : null}>
                    <FormattedDate value={this.state.details.validTo} {...DateStyles.long}  />
                </span>
            );
        }

        const scope = (this.state.details.trainer ? ` (Trainer)`  : '' );
        const avatarIcon = (<SkillIcon style={style.icon} color={isActive ? statusColours.primary : statusColours.disabled} />);

        // TODO: we should receive canEdit and canDelete properties from backEnd
        const canEdit = this.context.auth.isAdmin();

        const cardHeaderProps = (canEdit) ? {
            openIcon: <EditIcon onClick={() => this.editAction()}/>,
            closeIcon: <EditIcon onClick={() => this.editAction()}/>,
            showExpandableButton: true,
            expandable: false
        } : {};

        return (

            <DetailView
                title=''
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
            >
                <div className="cent-cards">
                    <div className="cent-col-8">
                        <Card className="cent-card">
                            <CardHeader {...cardHeaderProps}
                                className="cent-card-header"
                                title={this.state.details.name}
                                subtitle={this.state.details.code}
                                avatar={avatarIcon}
                            />
                            {!!this.state.details.description && (
                                <CardText className="cent-card-text">
                                    {this.state.details.description.split('\n').map((item, key) => <p key={key}>{item}</p>)}
                                    {!!this.state.details.criteria && (
                                        <div>
                                            <h3>Criteria</h3>
                                            <p>{this.state.details.criteria}</p>
                                        </div>
                                    )}
                                </CardText>
                            )}
                            <CardText>
                                <div className='cent-flex-row'>
                                    <div className='cent-col-2'>
                                        <ul className="cent-list-plain">
                                            <li><em>Level: </em>{this.state.details.level} {scope}</li>
                                            <li><em>Type: </em>{this.state.details.type}</li>
                                            <li><em>Available from: </em>{skillValidFrom}</li>
                                            {!!validTo && (<li><em>Available to: </em>{validTo}</li>)}
                                            {!!this.state.details.lifetime && (<li><em>Lifetime: </em>{this.state.details.lifetime} days</li>)}
                                        </ul>
                                    </div>
                                    <div className='cent-col-2'>
                                        <ul className="cent-list-plain">
                                            {!!this.state.details.certificate && (<li><em>Certificate: </em>{this.state.details.certificate}</li>)}
                                            <li><em>Acquisitions:</em> {this.state.details.acquisitions || 0}</li>
                                            <li><em>Compliance sets:</em> {this.state.details.complianceSets || 0}</li>
                                        </ul>
                                    </div>
                                </div>
                            </CardText>
                        </Card>
                    </div>

                    <div className="cent-col-4">
                        <UserSkillInformationSegment
                            skillId={this.props.id}
                            userId={this.props.userId || this.context.auth.identity.id}
                        />
                    </div>

                </div>

                {(this.state.courses.length > 0 || this.state.modules.length > 0) && (
                    <div className="cent-cards">
                        <div className="cent-cards-header">
                            <h3>"{this.state.details.name}" is linked to the following:</h3>
                        </div>
                    </div>
                )}


                {(this.state.courses.length > 0) && (
                    <div className="cent-cards">
                        {this.state.courses.map( (course) => (<CourseCard key={course.id} {...course} /> ))}
                    </div>
                )}
                {(this.state.modules.length > 0) && (
                    <div className="cent-cards">
                        <div className="cent-cards-header">
                            <h3>Modules</h3>
                        </div>
                        {this.state.modules.map( (module) => (
                            <Card className="cent-card cent-card-list-item" key={module.id}>
                                <ModuleListItem
                                    data={module}
                                    link={`/dashboard/category/${this.props.id}/module/${module.id}`}
                                />
                            </Card>
                        ))}
                    </div>
                )}
            </DetailView>
        );
    }

    onChange() {
        let details = SkillStore.getById(this.props.id);
        if (!!details) {
            this.setState({details});
        } else {
            this.setState({error: true});
        }
    }

    onCourseChange() {
        const courses = CourseStore.getBy({skillId: this.props.id});
        this.setState({courses});
    }

    onModuleChange() {
        const modules = ModuleStore.getBy({skillId: this.props.id});
        this.setState({modules});
    }

    onDelete(entityId) {
        if (entityId === this.props.id) {
            SkillActions.delete(entityId);
            window.location.href = this.state.links.back;
        }
    }

    editAction()  {
        browserHistory.push(`/dashboard/skill/${this.props.id}/edit`);
    }
}

Skill.contextTypes = {
    auth: PropTypes.object.isRequired
};

const SkillWithUserId = withMyUserId(Skill, {asFallback: true});
export default withId(SkillWithUserId, ({routeParams}) => ({
    id:     Number(routeParams.id),
    userId: Number(routeParams.userId) || null,
}));
